import { useRef, useEffect } from "preact/hooks";
import { useSort, useNostoAppState } from "@nosto/search-js/preact/hooks";
import { sortOptions } from "@/config";
import { useFilterSidebar } from "@/contexts/SidebarContext";
import FilterTopbar from "@/components/FilterTopbar/FilterTopbar";
import CustomSelect from "./CustomSelect";
import { pick } from "@nosto/search-js/utils";

type Props = {
  className?: string;
  productsCount?: number;
  showNoResults?: boolean;
};

const globalLanguage = window?.Bedrock?.language;

function ToggleFilterSidebarButton({ className }: Props) {
  const { toggle } = useFilterSidebar();

  return (
    <button className={className} onClick={toggle}>
      <span>{globalLanguage?.filter_button || "Filters"}</span>
      <span className="br-icon" aria-hidden="true">
        <svg>
          <use xlinkHref="#filter"></use>
        </svg>
      </span>
    </button>
  );
}

export default function Toolbar({ productsCount, showNoResults }: Props) {
  const isFirstRender = useRef(true);
  const { activeSort, setSort } = useSort(sortOptions);
  const { loading } = useNostoAppState((state) => pick(state, "loading"));

  const options = sortOptions.map((o) => ({
    value: o.id,
    label: o.value.name,
  }));

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
  });

  if (loading && isFirstRender.current) return <></>;

  return (
    <div className="plp__filter-header">
      <div className="filter-facets">
        <ToggleFilterSidebarButton className="filter-facets__mobile-trigger" />
        <FilterTopbar />
      </div>
      {!showNoResults && (
        <div className="filter-sort">
          <span className="hidden lg:block text-[13px]">
            {globalLanguage?.sort_button}:
          </span>
          <CustomSelect
            className="filter-sort__custom-select"
            options={options}
            placeholder="Sort"
            onChange={(val) => setSort(val)}
            value={activeSort}
          />
        </div>
      )}
      {productsCount !== 0 && !loading && (
        <div className="filter-count">{productsCount} products</div>
      )}
    </div>
  );
}
